import { createAsyncThunk } from "@reduxjs/toolkit";
import bandDashboardService from "../../../api/services/bandDashboard";
import festivalsService from "../../../api/services/festivals";

const normalizeOwnerArg = (arg) => {
  if (arg && typeof arg === "object") {
    return {
      bandId: arg.bandId,
      festivalId: arg.festivalId,
      params: arg.params || {},
    };
  }
  return { bandId: arg, festivalId: null, params: {} };
};

// Analytics (summary)
export const getBandAnalytics = createAsyncThunk(
  "bandDashboard/getBandAnalytics",
  async (arg, { rejectWithValue }) => {
    try {
      const { bandId, festivalId } = normalizeOwnerArg(arg);
      if (festivalId) {
        const response = await festivalsService.getFestivalAnalytics(festivalId);
        return response.data;
      }
      const response = await bandDashboardService.getBandAnalytics(bandId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getBandProductAnalytics = createAsyncThunk(
  "bandDashboard/getBandProductAnalytics",
  async (arg, { rejectWithValue }) => {
    try {
      const { bandId, festivalId } = normalizeOwnerArg(arg);
      if (festivalId) {
        const response = await festivalsService.getFestivalProductAnalytics(
          festivalId,
        );
        return response.data;
      }
      const response = await bandDashboardService.getBandProductAnalytics(
        bandId,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Products
export const getBandProducts = createAsyncThunk(
  "bandDashboard/getBandProducts",
  async ({ bandId, festivalId, ...params }, { rejectWithValue }) => {
    try {
      if (festivalId) {
        const response = await festivalsService.getProductsByFestival({
          id: festivalId,
          ...params,
        });
        return response;
      }
      const response = await bandDashboardService.getBandProducts(
        bandId,
        params,
      );
      // servis već vraća flat body { data, total, page, perPage }, bez duplog raspakivanja
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Orders
export const getBandOrders = createAsyncThunk(
  "bandDashboard/getBandOrders",
  async ({ bandId, festivalId, ...params }, { rejectWithValue }) => {
    try {
      if (festivalId) {
        const response = await festivalsService.getFestivalOrders(
          festivalId,
          params,
        );
        return response;
      }
      const response = await bandDashboardService.getBandOrders(bandId, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Monthly band revenues (legacy)
export const getBandMonthlyRevenues = createAsyncThunk(
  "bandDashboard/getBandMonthlyRevenues",
  async (bandId, { rejectWithValue }) => {
    try {
      const response = await bandDashboardService.getBandMonthlyRevenues(
        bandId,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getMonthlyBandRevenuesByPeriod = createAsyncThunk(
  "revenue/get-monthly-band-revenues-by-period",
  async ({ bandId, festivalId, startYear, startMonth, endYear, endMonth }) => {
    if (festivalId) {
      return await festivalsService.getMonthlyFestivalRevenuesByPeriod({
        festivalId,
        startYear,
        startMonth,
        endYear,
        endMonth,
      });
    }
    return await bandDashboardService.getMonthlyBandRevenuesByPeriod({
      bandId,
      startYear,
      startMonth,
      endYear,
      endMonth,
    });
  },
);
